<template>
  <div>
    <el-card>
      <el-page-header :content="title" style="margin-bottom: 30px" @back="goBack" />
      <nav class="input">
        <el-input
          v-model="search.keyword"
          size="medium"
          placeholder="用户ID、手机号、实名、昵称"
          clearable
        />
      </nav>
      <nav class="input" style="width: 380px">
        <label style="font-size: 14px; float: left; transform: translateY(9px); height: 40px">加入日期：</label>
        <el-date-picker
          v-model="joinDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 300px"
          size="medium"
        />
      </nav>
      <nav class="input" style="width: auto; height: 40px">
        <el-button type="primary" size="small" @click="onSearch">{{ btn ? '搜索' : 'loading..' }}</el-button>
        <el-button size="small" @click="onReset">重置</el-button>
      </nav>
    </el-card>

    <el-card style="margin-top: 10px">
      <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="userId" label="UID" width="90" />
        <el-table-column label="头像" width="120">
          <template slot-scope="{ row }">
            <el-image :src="baseurl + yu + row.avatar" :lazy="true" style="width: 90px">
              <div slot="error">
                <img :src="baseurl + yu + '/static/pc/img/avatar.png'" alt="" style="width: 90px" />
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="姓名" min-width="120">
          <template slot-scope="{ row }">
            {{ row.realName || row.nickname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="company" label="公司" min-width="140" show-overflow-tooltip />
        <el-table-column prop="job" label="职位" width="120" show-overflow-tooltip />
        <el-table-column prop="orderNo" label="订单号" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.orderNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-show="row.forms"
              type="text"
              icon="el-icon-video-camera-solid"
              size="mini"
              class="skyblue"
              @click="watchInfo(row)"
            >查看入群信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="search.page"
        background
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <Drawers ref="drawer" :title="'入群信息'" />
  </div>
</template>

<script>
import mixins from '@/mixin/list'

export default {
  name: 'CommunityMemberList',
  mixins: [mixins],
  data() {
    return {
      btn: true,
      communityId: '',
      joinDate: [],
      search: {
        page: 1,
        pageSize: 10,
        keyword: ''
      },
      queryParams: {}
    }
  },
  created() {
    this.communityId = this.$route.query.id
    if (!this.communityId) {
      this.$message.error('缺少社群ID')
      return
    }
    this.loadCommunityTitle()
    this.getlist()
  },
  methods: {
    async loadCommunityTitle() {
      const { data: res } = await this.$http.get('/admin/Community/getById', {
        params: { id: this.communityId }
      })
      if (res.errorCode == 200 && res.data) {
        this.title = res.data.name || '社群成员列表'
      }
    },
    getQueryParams() {
      const params = {
        communityId: this.communityId,
        page: this.search.page,
        pageSize: this.search.pageSize
      }
      if (this.search.keyword) params.keyword = this.search.keyword
      if (this.joinDate && this.joinDate.length === 2) {
        params.beginTime = this.joinDate[0]
        params.endTime = this.joinDate[1]
      }
      return params
    },
    getlist() {
      if (!this.communityId) return
      const params = Object.keys(this.queryParams).length ? { ...this.queryParams } : this.getQueryParams()
      this.$http
        .get('/admin/Community/getMemberList', { params })
        .then(({ data: res }) => {
          if (res.errorCode == 200) {
            this.list = res.data.list || []
            this.total = res.data.totalCount || 0
            if (res.data.community && res.data.community.name) {
              this.title = res.data.community.name
            }
            this.btn = true
          }
        })
    },
    onSearch() {
      if (!this.btn) return
      this.btn = false
      this.search.page = 1
      this.queryParams = this.getQueryParams()
      this.getlist()
    },
    onReset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.communityId = this.$route.query.id
      this.queryParams = {}
      this.loadCommunityTitle()
      this.getlist()
    },
    handleCurrentChange(page) {
      this.search.page = page
      this.queryParams = { ...this.getQueryParams(), page }
      this.getlist()
      this.$nextTick(() => {
        const main = document.querySelector('.el-main')
        if (main) main.scrollTop = 0
      })
    },
    watchInfo(row) {
      if (!row.forms) {
        this.$message.warning('暂无入群信息')
        return
      }
      this.$refs.drawer.drawer = true
      this.$refs.drawer.interfaces = 4
      try {
        this.$refs.drawer.ruleForm =
          typeof row.forms === 'string' ? JSON.parse(row.forms) : row.forms
      } catch (e) {
        this.$message.error('入群信息解析失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.input {
  width: 37%;
  display: inline-block;
  margin-right: 30px;
  margin-bottom: 10px;
}
.skyblue {
  color: skyblue;
}
</style>
